export default __webpack_public_path__ + "static/media/ic_gmx_custom_.fd35b66a.svg";